import { createMuiStyles } from '../../../../utils/mui';

export const featuredInstitutesStyles = createMuiStyles({
  illustration: {
    display: 'block',
    height: {
      xs: '15rem',
      sm: '20rem',
    },
    width: 'auto',
    overflow: 'visible',
  },
  sliderContainer: {
    '.featuredInstitutesSlider': {
      px: 'var(--container-fluid-padding)',
    },
    '.swiper-slide': {
      height: 'auto',
    },
  },
});
